import * as FavoritesActions from '~app/actions/favorites';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  locationInfos: [],
  favoriteMarkers: [],
};

function addFavorite(state, {locationInfo, marker}) {
  const newLocationInfos = [...state.locationInfos, locationInfo];
  const newFavoriteMarkers = [...state.favoriteMarkers, marker];

  return {
    ...state,
    locationInfos: newLocationInfos,
    favoriteMarkers: newFavoriteMarkers,
  };
}

function removeFavorite(state, {locationInfo, marker}) {
  const newLocationInfos = [...state.locationInfos];
  const newFavoriteMarkers = [...state.favoriteMarkers];
  const index = newFavoriteMarkers.indexOf(marker);
  if (index !== -1) {
    newFavoriteMarkers.splice(index, 1);
    newLocationInfos.splice(index, 1);
  }

  return {
    ...state,
    locationInfos: newLocationInfos,
    favoriteMarkers: newFavoriteMarkers,
  };
}

const ACTION_HANDLERS = {
  [FavoritesActions.ADD_FAVORITE]: addFavorite,
  [FavoritesActions.REMOVE_FAVORITE]: removeFavorite,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/favoritesReducer.js